module.exports = __webpack_public_path__ + "img/16.0a10dad0.jpg";